import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FangChipGroupComponent} from "./fang-chip-group.component";

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        FangChipGroupComponent
    ],
    declarations: [
        FangChipGroupComponent
    ],
    providers: [],
    entryComponents: [FangChipGroupComponent]
})
export class FangChipGroupModule {
}
